function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import { string, func, bool } from 'prop-types';
import { useFela } from 'react-fela';
import { Flex } from '../flex';
import { Block } from '../block';
import { Spacer } from '../spacer';
import { Spinner } from '../spinner';
import { Message } from '../message';
import { useId, makeIdList, makeId } from '../../auto-id';
import { getThemeStyle } from '../../get-theme-style';
import { deprecate } from '../../deprecate';
var LEGACY_PADDING = 16;

var defaultStyles = function defaultStyles(_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled,
      loading = _ref.loading,
      isValid = _ref.isValid,
      hasLabel = _ref.hasLabel;
  return _objectSpread(_objectSpread({
    appearance: 'none',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 4,
    boxSizing: 'border-box',
    display: 'block',
    width: '100%',
    margin: 0,
    outline: 0,
    paddingTop: theme.tokens.inputPaddingVertical * 2,
    paddingBottom: theme.tokens.inputPaddingVertical / 2,
    paddingLeft: theme.tokens.inputPaddingHorizontal - 1,
    paddingRight: theme.tokens.inputPaddingHorizontal - 1,
    borderColor: theme.tokens.inputBorder,
    color: theme.tokens.inputForeground,
    background: theme.tokens.inputBackground
  }, theme.typeScale.columbus.standard.styles), {}, {
    '::placeholder': {
      color: 'transparent'
    },
    ':focus': {
      borderColor: theme.tokens.inputBorderFocus,
      '::placeholder': {
        color: theme.tokens.inputPlaceholder
      },
      '& + label': {
        transform: 'translateY(8px)',
        fontSize: 12
      }
    },
    extend: [{
      condition: loading,
      style: {
        userSelect: 'none'
      }
    }, {
      condition: disabled,
      style: {
        ':disabled': {
          cursor: 'not-allowed',
          borderColor: theme.tokens.inputDisabledBorder,
          backgroundColor: theme.tokens.inputDisabledBackground,
          color: theme.tokens.inputForeground,
          '& + label': {
            cursor: 'not-allowed'
          }
        }
      }
    }, {
      condition: !isValid,
      style: {
        ':not(:focus)': {
          borderWidth: 2,
          borderColor: theme.color.foreground.alert,
          paddingTop: theme.tokens.inputPaddingVertical * 2 - 1,
          paddingBottom: theme.tokens.inputPaddingVertical / 2 - 1,
          paddingLeft: theme.tokens.inputPaddingHorizontal - 2,
          paddingRight: theme.tokens.inputPaddingHorizontal - 2
        }
      }
    }, {
      condition: !hasLabel,
      style: {
        paddingTop: LEGACY_PADDING - 1,
        paddingBottom: LEGACY_PADDING - 1,
        '::placeholder': {
          color: theme.tokens.inputPlaceholder
        },
        extend: [{
          condition: !isValid,
          style: {
            ':not(:focus)': {
              borderWidth: 2,
              borderColor: theme.color.foreground.alert,
              paddingTop: LEGACY_PADDING - 2,
              paddingBottom: LEGACY_PADDING - 2,
              paddingLeft: theme.tokens.inputPaddingHorizontal - 2,
              paddingRight: theme.tokens.inputPaddingHorizontal - 2
            }
          }
        }]
      }
    }]
  });
};

var labelStyle = function labelStyle(_ref2) {
  var isEmpty = _ref2.isEmpty,
      isValid = _ref2.isValid,
      theme = _ref2.theme;
  return {
    paddingLeft: theme.tokens.inputPaddingHorizontal,
    paddingRight: theme.tokens.inputPaddingHorizontal,
    color: isValid ? theme.color.foreground.secondary : theme.color.foreground.alert,
    transitionProperty: 'font-size, transform',
    transitionDuration: '60ms',
    transitionTimingFunction: 'ease-out',
    transform: 'translateY(' + (isEmpty ? 17 : 8) + 'px)',
    fontSize: isEmpty ? 16 : 12,
    letterSpacing: '0.02em',
    fontFamily: theme.fontTypes.NOVUM,
    fontWeight: 300,
    position: 'absolute',
    pointerEvents: 'none',
    top: 0
  };
};

export var TextInput =
/*#__PURE__*/
React.forwardRef(function (_ref3, ref) {
  var onChange = _ref3.onChange,
      type = _ref3.type,
      _ref3$value = _ref3.value,
      value = _ref3$value === void 0 ? '' : _ref3$value,
      _ref3$isValid = _ref3.isValid,
      isValid = _ref3$isValid === void 0 ? true : _ref3$isValid,
      _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? '' : _ref3$label,
      _ref3$description = _ref3.description,
      description = _ref3$description === void 0 ? '' : _ref3$description,
      _ref3$errorMessage = _ref3.errorMessage,
      errorMessage = _ref3$errorMessage === void 0 ? '' : _ref3$errorMessage,
      _ref3$loading = _ref3.loading,
      loading = _ref3$loading === void 0 ? false : _ref3$loading,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      props = _objectWithoutProperties(_ref3, ["onChange", "type", "value", "isValid", "label", "description", "errorMessage", "loading", "disabled"]);

  var _useFela = useFela(),
      theme = _useFela.theme; // legacy check


  var hasLabel = label.length > 0;
  deprecate('Unlabelled text-input fields are deprecated and will be removed in 3.0.0. Pass a label prop.', !hasLabel);
  var isEmpty = value.length === 0;
  var styleProps = {
    isEmpty: isEmpty,
    hasLabel: hasLabel,
    isValid: isValid,
    disabled: disabled,
    loading: loading,
    theme: theme
  };
  var id = useId('vcc-ui-text-input', props.id);
  var errorMessageId = makeId(id, 'error');
  var descriptionId = makeId(id, 'description');
  var describedBy = makeIdList([errorMessage && errorMessageId, description && descriptionId]);
  var messages =
  /*#__PURE__*/
  React.createElement(React.Fragment, null, errorMessage || description ?
  /*#__PURE__*/
  React.createElement(Spacer, {
    size: 0.5
  }) : null, errorMessage ?
  /*#__PURE__*/
  React.createElement(Message, {
    type: "error",
    id: errorMessageId
  }, errorMessage) : null, description ?
  /*#__PURE__*/
  React.createElement(Message, {
    id: descriptionId
  }, description) : null);
  return (
    /*#__PURE__*/
    React.createElement(Flex, {
      extend: {
        flexDirection: 'column',
        width: '100%'
      }
    },
    /*#__PURE__*/
    React.createElement(Flex, {
      extend: {
        position: 'relative'
      }
    }, loading &&
    /*#__PURE__*/
    React.createElement(Flex, {
      extend: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center'
      }
    },
    /*#__PURE__*/
    React.createElement(Spinner, {
      color: theme.tokens.inputForeground,
      size: 24
    })),
    /*#__PURE__*/
    React.createElement(Block, _extends({}, props, {
      ref: ref,
      as: "input",
      value: loading ? '' : value,
      disabled: disabled || loading,
      type: type,
      id: id,
      onChange: onChange,
      extend: [defaultStyles(styleProps), getThemeStyle('textInput', theme, styleProps)]
    }, describedBy && {
      'aria-describedby': describedBy
    })), !loading && hasLabel ?
    /*#__PURE__*/
    React.createElement(Block, {
      as: "label",
      htmlFor: id,
      extend: labelStyle(styleProps)
    }, label) : null), messages)
  );
});
TextInput.displayName = 'TextInput';
TextInput.propTypes = {
  type: string,
  id: string,
  name: string,

  /** Renders a label inside the input. */
  label: string,

  /** Renders a description text underneath the input. */
  description: string,

  /** Renders a red error message for validation underneath the input. */
  errorMessage: string,

  /** onChange handler. Triggers on every keyboard and generally
   * is here where you change the value of the `value` property. */
  onChange: func.isRequired,

  /** Value of the textInput. This should be stored in the
   * state of the parent component. */
  value: string.isRequired,

  /** Renders the input as valid or invalid. */
  isValid: bool,
  loading: bool,
  disabled: bool
};